import BidWizard from "@/components/bid/Index";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Homes For Sale | Online Real Estate Auctions | Properties | Hubzu",
};

const BidLayout = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <BidWizard />
    </>
  );
};

export default BidLayout;
